import { PERMISSION_KEYS } from './permissionKeys'

/**
 * Resolved home (and similar shell) layout for the signed-in user.
 * Add new values here when introducing Transform-only or other limited experiences.
 */
export const HOME_EXPERIENCE = {
  FULL: 'full',
  CONTENT_LIBRARY_ONLY: 'contentLibraryOnly',
  TRANSFORM_ONLY: 'transformOnly'
}

/**
 * @param {{ accessLoaded: boolean, hasPermission: (key: string) => boolean }} auth
 * @returns {typeof HOME_EXPERIENCE[keyof typeof HOME_EXPERIENCE] | null}
 */
export function resolveHomeExperience(auth) {
  if (!auth.accessLoaded) {
    return null
  }

  const hasCore = auth.hasPermission(PERMISSION_KEYS.CORE_ACCESS)
  const hasCl = auth.hasPermission(PERMISSION_KEYS.CONTENT_LIBRARY_ACCESS)
  const hasTransform = auth.hasPermission(PERMISSION_KEYS.TRANSFORM_ACCESS)

  if (hasCore) {
    return HOME_EXPERIENCE.FULL
  }
  if (hasCl) {
    return HOME_EXPERIENCE.CONTENT_LIBRARY_ONLY
  }
  if (hasTransform) {
    return HOME_EXPERIENCE.TRANSFORM_ONLY
  }
  return HOME_EXPERIENCE.FULL
}
